import Builder from '../Builder/Section';
export var VarColumnWrapper = Builder({
  tagName: 'article',
  className: 'var-column__wrapper'
});
export var VarColumnFlex = Builder({
  className: 'var-column__flex'
});
export var VarColumnWrap = Builder({
  className: 'var-column__wrap'
});
export var VarColumn = Builder({
  className: 'var-column',
  tagName: function tagName(props) {
    return props.footer ? 'footer' : 'section';
  }
});